import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgComments = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7 20C6.45 20 6 19.55 6 19V16H2C0.9 16 0 15.1 0 14L0 2C0 0.89 0.9 0 2 0L18 0C19.1 0 20 0.9 20 2V14C20 15.1 19.1 16 18 16H11.9L8.2 19.71C8 19.9 7.75 20 7.5 20H7ZM8 14V17.08L11.08 14H18V2H2V14H8Z",
		fill: "#C6CDD2"
	})
});
export default SvgComments;
